import Loading from '../../../../../../components/Loading';
import AccordionAward from '../../../../../Giveaways/ViewGiveaway/components/AccordionAward';
import useGiveawayAutoAwards from './useGiveawayAutoAwards';
import ConfirmValidateAwardModal from '../../../../GiveawayAutoWinners/components/ConfirmValidateAwardModal';

export default function GiveawayAwardsAuto() {
    const {
        tableData,
        invalidating,
        isConfirmValidateAwardModalVisible,
        handleValidateFinished,
        handleCancelValidateAward,
        selectedAward,
        onClickViewAppUser,
        handleClickValidateAward,
        isLoading
    } = useGiveawayAutoAwards();

    return (
        <>
            <Loading loading={isLoading} ></Loading>
            {tableData.map((data, index) => {
                return <AccordionAward
                    key={index}
                    award={data}
                    onChangeStatus={handleClickValidateAward}
                    onVerUsuario={onClickViewAppUser}
                />
            })}

            {
                isConfirmValidateAwardModalVisible && (
                    <ConfirmValidateAwardModal
                        open={true}
                        award={selectedAward}
                        latestAwardHistory={selectedAward?.award_history?.slice().sort((a, b) => b.id - a.id)[0]}
                        invalidating={invalidating}
                        onValidateFinished={handleValidateFinished}
                        onCancel={handleCancelValidateAward}
                    />
                )
            }
        </>
    )
}
